// utils/broadcast.js
export const channel = new BroadcastChannel('redux-sync');

export const broadcastReduxState = (key, value) => {
    channel.postMessage({ key, value });
};
